import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13aaa717"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-title" }
const _hoisted_2 = { class: "section-name" }
const _hoisted_3 = { class: "row" }

import Controller from './controller.vue';
  import { reactive, inject, computed, Ref, ref, watchEffect } from 'vue';
  import { StoryItem } from '@/types/story';
  import { ICustomList } from '@/types/custom-list';
  import { FormItem } from '@/types/form';
  import { request } from '@/utils';
  import { useI18n } from 'vue-i18n';

  export interface IForm {
    id?: number;
  }
  export interface IProps {
    props: IForm
    modelValue?: boolean;
  }
  export interface IEmits {
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: IForm): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    props: null,
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: IForm): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    props: IForm
    modelValue?: boolean;
  }

  const { t } = useI18n();
  
  

  const editorMode = inject('editorMode');
  const customList: Ref<ICustomList[]> = inject('stories', ref([]));

  const stories = ref<StoryItem[]>([]);

  const form = reactive<IForm>({});
  const formList = computed(() => {
    const list: FormItem[] = [
      customList.value.length && {
        label: 'Select list',
        type: 'select',
        key: 'id',
        required: false,
        options: customList.value.map(item => ({ text: item.title, value: item.id }))
      }
    ].filter(Boolean) as FormItem[];
    return list;
  });
  const handleChange = (form: IForm) => {
    emits('change', form);
  };

  watchEffect(async () => {
    const id = props.props.id;
    if (id) {
      form.id = id;
      const { data } = await request.get(`custom_lists/${id}`);
      // 只显示3条
      stories.value = ((data as ICustomList).custom_lists_items || [])
        .map(listItem => listItem.item as StoryItem)
        .slice(0, 3);
    } else {
      stories.value = [];
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppCardStory = _resolveComponent("AppCardStory")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(editorMode))
      ? (_openBlock(), _createBlock(Controller, {
          key: 0,
          title: "Story",
          visible: __props.modelValue,
          "form-list": _unref(formList),
          form: _unref(form),
          "onUpdate:visible": _cache[0] || (_cache[0] = visible => emits('update:modelValue', visible)),
          onChange: handleChange
        }, null, 8, ["visible", "form-list", "form"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(t)('Story')), 1),
      _createVNode(_component_router_link, {
        class: "more",
        to: { name: 'story.index' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('more')) + "> ", 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stories.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col-12 col-md-4"
        }, [
          _createVNode(_component_AppCardStory, { data: item }, null, 8, ["data"])
        ]))
      }), 128))
    ])
  ]))
}
}

})